module.exports = __webpack_public_path__ + "static/img/scene4.0fd4e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene4.png
// module id = BRZJ
// module chunks = 1